import React, { useState } from 'react';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';

// Helpers
import { showMessage, showQuestion } from '../../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../../helpers/mascaras';

// Constants
import { actionsTable } from '../../../../../constants/MaterialTable';

// Componentes
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';
import TextField from '../../../../../components/TextField';
import Loading from '../../../../../components/Loading/Loading';

// API
import tipoDeFiscalizacao_api from '../../../../../api/tipoDeFIscalizacao_api';

function initialStateService(tipoFiscalizacao_id) {
  return {
    tipoFiscalizacao_Id: tipoFiscalizacao_id,
    identificacao: "",
    prazoInicial: "0",
    excluido: false
  }
};

export default function Servicos({ tipoDeFiscalizacao, loadTipoDeFiscalizacaoItem, editavel = false }) {
  //state para visibilidade do campos de preenchimentos
  const [visibleForm, setVisibleForm] = useState(false);

  // state para loading
  const [showLoading, setShowLoading] = useState(false);

  // state para criar servicos
  const [servico, setServico] = useState(initialStateService(tipoDeFiscalizacao.id));

  //Estado de controle dos erros
  const [errors, setErrors] = useState({});

  const loadResetState = () => {
    setVisibleForm(false);
    loadTipoDeFiscalizacaoItem(tipoDeFiscalizacao.id);
    setServico(initialStateService(tipoDeFiscalizacao.id));
  }

  //Cabeçalhos da lista de certificados
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Prazo", objectValue: "prazoInicial", align: "left" }
  ];

  //Campos obrigatorios
  const camposIdentificacao = [
    objCampo({ name: "identificacao", required: true }),
    objCampo({ name: "prazoInicial", required: true })
  ]

  //Função para remover editar
  const editar = (rowData) => {
    setVisibleForm(true);
    setServico(rowData);
  }

  const visualizar = (rowData) => {
    setVisibleForm(true);
    setServico(rowData);
  }


  //Função para remover serviço
  const remover = (rowData) => {
    showQuestion("Tem certeza?", "Tem certeza de que deseja deletar essa questão?\n Esta ação é irreversível", "info",
      (confirmation) => {
        if (confirmation) {
          setShowLoading(true)
          tipoDeFiscalizacao_api.DeleteTipoFiscalizacaoServicos(rowData.id).then(response => {
            showMessage("Aviso", "Tipo fiscalização removido com sucesso", "success", null);
            loadResetState();
          }).catch(err => showMessage("Aviso", err.message, "error", null))
            .finally(() => setShowLoading(false))
        }
      })
  }

  //Ações que a tabela terá
  const actions = [
    ...editavel
    ? [actionsTable.editar(editar), actionsTable.remover(remover)]
    : [actionsTable.visualizar(visualizar)]
  ];

  //Função para modificar os states
  const onChange = (e) => {
    const { name, value } = e.target;
    setServico({
      ...servico,
      [name]: value
    })
  }

  //Função para salvar serviços
  const salveServico = () => {
    const _errors = validarCampos(servico, camposIdentificacao);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    const _servico = { ...servico };

    if (_servico.id) {
      setShowLoading(true)
      tipoDeFiscalizacao_api.putTipoFiscalizacaoServicos(_servico).then(response => {
        showMessage("Aviso", "Operação realizada com sucesso", "success", null);
        loadResetState();
      }).catch(err => showMessage("Aviso", err.message, "error", null))
        .finally(() => setShowLoading(false))
    } else {
      setShowLoading(true)
      tipoDeFiscalizacao_api.postTipoFiscalizacaoServicos(_servico).then(response => {
        showMessage("Aviso", "Operação realizada com sucesso", "success", null);
        loadResetState();
      }).catch(err => showMessage("Aviso", err.message, "error", null))
        .finally(() => setShowLoading(false))
    }
  }

  return <>
    {showLoading && <Loading />}
    <h5 className='mb-3 d-flex align-items-center justify-content-between'>Serviços {editavel ? <Button color='success' onClick={() => setVisibleForm(!visibleForm)}>+ Adicionar</Button> : <></>}</h5>
    <div className={`formContainer ${!visibleForm ? "close" : "mb-3"}`}>
      <Row>
        <Col md="12" lg="8">
          <TextField
            name={"identificacao"}
            label={"Identificação"}
            onChange={onChange}
            value={servico.identificacao}
            invalid={!!errors.identificacao}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="4">
          <TextField
            name={"prazoInicial"}
            label={"Prazo em Dias"}
            type={"text"}
            mask={mascaras.numeroMask}
            onChange={onChange}
            value={servico.prazoInicial}
            invalid={!!errors.prazoInicial}
            disabled={!editavel}
          />
        </Col>
        <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
          <Button className='px-4 mb-5 me-4' color={"secondary"} onClick={() => setServico(initialStateService(tipoDeFiscalizacao))}>Cancelar</Button>
          <Button className='px-4 mb-5' color={servico.tableData ? 'warning text-white' : 'success'} onClick={salveServico}>{servico.tableData ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Adicionar"}</Button>
        </Col>
      </Row>
    </div>
    <TabelaListagem
      actions={actions}
      title={"Lista de Serviços"}
      headers={headers}
      items={tipoDeFiscalizacao.tipoFiscalizacaoServicos}
    />
  </>;
}